<template>
	<b-modal
		ref="modal-Create"
		@hidden="$emit('close')"
		:title="`${form.id ? 'Actualizar categoria' : 'Agregar categoria'}`"
		cancel-title="Cancelar"
		scrollable
		size="md"
		no-close-on-backdrop
		no-close-on-esc
	>
		<div>
			<ValidationObserver ref="formCategories">
				<b-col>
					<ValidationProvider v-slot="{ errors }" rules="required">
						<b-form-group :state="errors[0] ? false : null">
							<label for="name">Nombre</label>
							<b-form-input
								id="name"
								:state="errors[0] ? false : null"
								type="text"
								v-model="form.name"
								placeholder="Ingrese nombre de la categoria"
							/>
						</b-form-group>
					</ValidationProvider>
				</b-col>
			</ValidationObserver>
		</div>
		<template #modal-footer>
			<b-button variant="danger" @click="closeModal">Cancelar</b-button>
			<b-button variant="outline-primary" @click="form.id ? UpdateCategories() : registerCategories()">
				{{ form.id ? "Actualizar" : "Guardar" }}
			</b-button>
		</template>
	</b-modal>
</template>

<script>
import modalMixin from "@/mixins/modal.js"
import Ripple from "vue-ripple-directive"
import serviceCategories from "@/views/brain/administrative/views/categories/services/categories.service.js"
export default {
	props: {
		info: {
			required: true,
		},
	},
	directives: { Ripple },
	mixins: [modalMixin],
	data() {
		return {
			form: {
				id: null,
				name: null,
			},
		}
	},
	async mounted() {
		this.toggleModal("modal-Create")
	},
	created() {
		if (this.info.id != null) {
			this.form.id = this.info.id
			this.form.name = this.info.name
		}
	},
	methods: {
		async registerCategories() {
			const validate = await this.$refs.formCategories.validate()
			if (!validate) return

			const { isConfirmed } = await this.showConfirmSwal({ text: `Registrar categoria: ${this.form.name}.` })
			if (!isConfirmed) return
			this.isPreloading()

			try {
				const params = {
					name: this.form.name,
				}
				const data = await serviceCategories.createCategories(params)
				this.showSuccessToast(data.message)
				this.$emit("registered")
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},

		async UpdateCategories() {
			const validate = await this.$refs.formCategories.validate()
			if (!validate) return

			const { isConfirmed } = await this.showConfirmSwal({ text: `Actualizando categoria: ${this.form.name}.` })
			if (!isConfirmed) return
			this.isPreloading()
			try {
				const params = {
					name: this.form.name,
				}
				const data = await serviceCategories.updateCategories(this.form.id, params)
				this.form.id = null
				this.form.name = null
				this.showSuccessToast(data.message)
				this.$emit("registered")
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		closeModal() {
			this.$emit("close")
		},
	},
}
</script>
